import React, { useReducer, useState, useContext } from 'react';

import facturaContext from './facturaContext';
import facturaReducer from './facturaReducer';

import AuthContext from '../autenticacion/authContext';

import { 
    FORMULARIO_FACTURA, 
    OBTENER_FACTURAS,
    AGREGAR_FACTURA,
    FACTURA_ERROR,
    VALIDAR_FORMULARIO_FACTURA,
    FACTURA_ACTUAL,
    CANCELAR_FACTURA,
    ACTUALIZAR_ENVIADA
} from '../../types';

import clienteAxios from '../../config/axios';


const FacturaState = props => {

    const authContext = useContext(AuthContext);
    const { cerrarSesion } = authContext;
    
    // const [pagina, setPagina] = useState(1);

    const initialState = {
        facturas : [],
        paginacion : [],
        formulario : false,
        errorformulario: false,
        proyecto: null, 
        mensaje: null,
        cargando_facturas: true,
    }

    // Dispatch para ejecutar las acciones
    const [state, dispatch] = useReducer(facturaReducer, initialState)

    // Serie de funciones para el CRUD
    const mostrarFormulario = () => {
        dispatch({
            type: FORMULARIO_FACTURA
        })
    }

    // Obtener los proyectos
    //const obtenerFacturas = async (pagina, desde, hasta, serie, folio, estado, rfc, razon_social) => {
    //const obtenerFacturas = async (pagina, serie, folio) => {
    const actualizarEnviada = (factu) => {
        dispatch({
            type: ACTUALIZAR_ENVIADA,
            payload: factu
        })
    } 
    async function obtenerFacturas (pagina, {desde, hasta, serie, folio, estado, rfc, razon_social}) {
        
        //console.log('ESTOS SON LOS PARAMETROS '+folio);
        try {
            //const resultado = await clienteAxios.get(`/v3/facturas?page=${pagina}`,{params: {parametros}});
            const resultado = await clienteAxios.get('/v3/facturas',{params: {
                page: pagina,
                desde,
                hasta,
                serie,
                folio,
                estado,
                rfc,
                razon_social
               
            }});
            dispatch({
                type: OBTENER_FACTURAS,
                payload: resultado.data
            })
        } catch (error) {
            if(error.response.status===401){
                cerrarSesion();
            }
            const alerta = {
                msg: 'Hubo un error',
                categoria: 'alerta-error'
            }
            
            dispatch({
                type: FACTURA_ERROR,
                payload: alerta
            })
        }
    }

    // Agregar nuevo proyecto
    const agregarProyecto = async proyecto => {

        try {
            const resultado = await clienteAxios.post('/v3/facturas', proyecto);
            console.log(resultado);
            // Insertar el proyecto en el state
            dispatch({
                type: AGREGAR_FACTURA,
                payload: resultado.data
            })
        } catch (error) {

            const alerta = {
                msg: 'Hubo un error',
                categoria: 'alerta-error'
            }
            
            dispatch({
                type: FACTURA_ERROR,
                payload: alerta
            })
        }
    }

    // Valida el formulario por errores
    const mostrarError = () => {
        dispatch({
            type: VALIDAR_FORMULARIO_FACTURA
        })
    } 

    // Selecciona el Proyecto que el usuario dio click
    const proyectoActual = proyectoId => {
        dispatch({
            type: FACTURA_ACTUAL,
            payload: proyectoId
        })
    }

    // Elimina un proyecto
    const eliminarProyecto = async proyectoId => {
        try {
            await clienteAxios.delete(`/v3/facturas/${proyectoId}`);
            dispatch({
                type: CANCELAR_FACTURA,
                payload: proyectoId
            })
        } catch (error) {
            const alerta = {
                msg: 'Hubo un error',
                categoria: 'alerta-error'
            }
            
            dispatch({
                type: FACTURA_ERROR,
                payload: alerta
            })
        }
    }


    return (
        <facturaContext.Provider
            value={{
                facturas: state.facturas,
                paginacion: state.paginacion,
                formulario: state.formulario,
                errorformulario: state.errorformulario,
                proyecto: state.proyecto,
                mensaje: state.mensaje,
                cargando_facturas: state.cargando,
                mostrarFormulario,
                obtenerFacturas,
                agregarProyecto,
                mostrarError,
                proyectoActual,
                eliminarProyecto,
                actualizarEnviada
                // pagina, 
                // setPagina
                
            }}
        >
            {props.children}
        </facturaContext.Provider>
        
    )
}

export default FacturaState;